import React from 'react';

import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';

interface IIconLogsResultProps {
    code: number;
}

const IconLogsResult: React.FC<IIconLogsResultProps> = ({code}) => {

    if (code === 200) {
        return (
            <SuccessfulMonitor />
        )
    }

    return (
        <ProblemMonitor />
    );
};

export default IconLogsResult;